export const Ten = 'J';